import { render, staticRenderFns } from "./OrDivider.vue?vue&type=template&id=18832877&scoped=true"
import script from "./OrDivider.vue?vue&type=script&lang=js"
export * from "./OrDivider.vue?vue&type=script&lang=js"
import style0 from "./OrDivider.vue?vue&type=style&index=0&id=18832877&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18832877",
  null
  
)

export default component.exports